export default __webpack_public_path__ + "images/models/055375e3f881c6daaa7e5fe5ad6b8845.glb";